import React from 'react';

/**
 * Utility function to parse bold text marked with ** in a string.
 * It splits the string into React nodes with <strong> for bolded text.
 *
 * @param input - The input string containing text with **bold** syntax.
 * @returns React.ReactNode - A parsed React node with bolded words.
 */
export function parseMarkdownBold(input: string): React.ReactNode {
  // Regular expression to match text between **...**
  const regex = /\*\*(.*?)\*\*/g;

  // Split the input string into parts
  const parts = input?.split(regex);

  // Map over parts and replace bolded segments with <strong>
  return parts?.map((part, index) => {
    if (index % 2 === 1) {
      // Odd indices contain bolded text
      return <strong key={index}>{part}</strong>;
    }
    return part; // Regular text
  });
}
